import React from 'react';
import { motion } from 'framer-motion';
import { data } from '@/data';
import SEO from '@/components/SEO';
import { getPageSEO } from '@/config/seoConfig';
import { useTranslation } from '@/hooks/useTranslation';

const Repertoire = () => {
  const seoData = getPageSEO('repertoire');
  const t = useTranslation();
  
  return (
    <>
      <SEO 
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        url={seoData.url}
        image={seoData.image}
        type="website"
      />
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-stone-100/50 pt-32 pb-20">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-playfair text-4xl md:text-5xl lg:text-6xl mb-16 text-gray-800 text-center font-semibold tracking-tight"
        >
          {t.repertoire.title}
        </motion.h1>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Repertoire List */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-10 bg-white/70 backdrop-blur-sm p-8 rounded-2xl shadow-lg"
          >
            {(
              // Prefer translated repertoire list when available (pt), otherwise use data.repertoire
              (t.repertoire && t.repertoire.list ? t.repertoire.list : data.repertoire)
            ).map((section, sectionIndex) => (
              <motion.div
                key={sectionIndex}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 + sectionIndex * 0.1 }}
                className="space-y-4"
              >
                <h2 className="font-playfair text-2xl md:text-3xl text-gray-900 mb-4 font-medium tracking-tight">
                  {section.composer}
                </h2>
                <ul className="space-y-2">
                  {section.pieces.map((piece, pieceIndex) => (
                    <li
                      key={pieceIndex}
                      className="font-lora text-gray-600 text-base md:text-lg leading-relaxed pl-4 border-l-2 border-amber-200 hover:border-amber-300 transition-colors duration-300 tracking-wide hover:text-gray-700"
                    >
                      {piece}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="sticky top-32"
          >
            <div className="aspect-[3/4] overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="/images/João_Xavier_repertoire.webP"
                alt="Piano performance"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Repertoire;